import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const add = params => {
  return ApiService.post(`estimate`, params);
};

export const getById = params => {
  return ApiService.query(`estimate/${params.id}`);
};

export const modifyById = params => {
  return ApiService.put(`estimate/${params.id}`, params);
};

export const removeById = params => {
  return ApiService.delete(`estimate/${params.id}`, params);
};

export const getList = params => {
  return ApiService.query(`estimate/me?${stringify(params)}`);
};

export const getInProgressAutoEstimate = params => {
  return ApiService.query(`estimate/auto/inprogress?${stringify(params)}`);
};

export const getLatelyEstimate = params => {
  return ApiService.query(`estimate/lately?${stringify(params)}`);
};
